import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import BzmIcon from '../../../components/icons/BzmIcon';
import i18n from '../../../i18n';
import WizardModal from '../../../components/modal/WizardModal';

const StartMockingBtn = () => {
  const [isWizardShown, setIsWizardShown] = useState(false);

  return (
    <>
      {isWizardShown && (
        <WizardModal
          onClose={() => {
            setIsWizardShown(false);
          }}
        />
      )}
      <div className={'position-absolute'} style={{ top: 6, right: 6 }}>
        <Button
          className={'font-weight-semi-bold btn-no-hover'}
          id={'qa-dd-panel-toggle'}
          variant={'link'}
          onClick={() => {
            setIsWizardShown(true);
          }}
        >
          <BzmIcon variant={'icon-bzm-setup-wizard'} className={'ml-1 mr-3'}></BzmIcon>
          {i18n.t('wizard:startNow')}
        </Button>
      </div>
    </>
  );
};

export default StartMockingBtn;
